import { useMemo } from 'react';
import { useAuth } from '../../../app/providers/AuthProvider';
import {
  PermissionChecker,
  type PermissionContext,
  type GroupMemberRole,
} from '@penticton-dev-events/shared';
import type { GroupMember } from '@penticton-dev-events/shared';

/**
 * Hook to create a permission checker for the current user
 * Optionally pass group member information for group-level permissions
 */
export const usePermissions = (groupMember?: GroupMember | null) => {
  const { user, profile } = useAuth();

  const context: PermissionContext = useMemo(
    () => ({
      user:
        user && profile
          ? {
              uid: user.uid,
              isAdmin: profile.isAdmin,
            }
          : null,
      groupMember: groupMember
        ? {
            role: groupMember.role as GroupMemberRole,
            status: groupMember.status,
          }
        : null,
    }),
    [user, profile, groupMember],
  );

  return useMemo(() => new PermissionChecker(context), [context]);
};

/**
 * Hook to check if the current user is a platform admin
 */
export const useIsPlatformAdmin = (): boolean => {
  const { profile } = useAuth();
  return profile?.isAdmin === true;
};
